import React from "react";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import { useLocation } from "react-router-dom";
import InventoryHero from "../InventoryHero";

const INVENTORY_ROUTE_LABELS = {
  "/inventory": "Inventory",
  "/inventory/daily-stock": "Daily Stock",
  "/inventory/restock": "Restock",
  "/inventory/archive": "Archive",
  "/inventory/history": "History",
};

const InventoryRouteFallback = () => {
  const { pathname } = useLocation();
  const sectionLabel = INVENTORY_ROUTE_LABELS[pathname] || "Inventory";

  return (
    <Box sx={{ p: { xs: 1.5, sm: 3 } }}>
      <InventoryHero />
      <Paper
        component="section"
        role="status"
        aria-live="polite"
        aria-busy="true"
        variant="outlined"
        sx={{
          minHeight: { xs: 280, sm: 340 },
          p: { xs: 2, sm: 3 },
          borderRadius: 3,
          overflow: "hidden",
          bgcolor: "background.paper",
          boxShadow: "0 8px 24px rgba(45, 24, 63, 0.06)",
        }}
      >
        <Typography variant="h5" component="h1" fontWeight={800}>
          Loading {sectionLabel}
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 0.5, mb: 2 }}>
          Please wait. Your inventory page is opening.
        </Typography>
        <LinearProgress
          aria-label={`Loading ${sectionLabel}`}
          sx={{ mb: 3, borderRadius: 999 }}
        />
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))" },
            gap: 2,
          }}
        >
          {[0, 1, 2, 3].map((item) => (
            <Skeleton
              key={item}
              variant="rounded"
              height={82}
              animation="wave"
              sx={{ borderRadius: 2 }}
            />
          ))}
        </Box>
      </Paper>
    </Box>
  );
};

export default InventoryRouteFallback;
